(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/behaviors/trackga.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/behaviors/trackga.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

(function (Backbone, _, svs) {
  'use strict';

  const productMappingNumbergames = svs.numbergames.productMapping;
  svs.tur.start_subscription.behaviors.TrackGa = Marionette.Behavior.extend({
    CONSTANTS: {
      BANK_CARD: 'creditcard',
      AUTOGIRO: 'autogiro',
      STATUS: {
        1: 'Activate',
        3: 'Reactivate'
      },
      LYCKOPLATSEN: {
        productName: 'Lyckoplatsen',
        itsId: {
          48: 'LYCKOPLATSEN_PRIMARY',
          49: 'LYCKOPLATSEN_SECONDARY'
        },
        wagersId: {
          GEO1: 'LYCKOPLATSEN_PRIMARY',
          GEO2: 'LYCKOPLATSEN_SECONDARY'
        },
        LYCKOPLATSEN_PRIMARY: 'LYCKOPLATSEN_PRIMARY',
        LYCKOPLATSEN_SECONDARY: 'LYCKOPLATSEN_SECONDARY'
      }
    },

    onStartSubscription(subscriptionOptions) {
      this.subscriptionOptions = subscriptionOptions;
      this.weeklyCost = subscriptionOptions.options.weeklyCost;
      this.productName = subscriptionOptions.options.product;

      if (productMappingNumbergames.isProductFamily(this.productName)) {
        this.productName += " ".concat(subscriptionOptions.options.gameDays);
      }
    },
    onStartShowChoosePaymenttype(context) {
      let paymentTypeText;
      this.trackEvent = 'Started First';
      if (context.entryModel.has('paymentType')) {
        paymentTypeText = "changeable ".concat(this.CONSTANTS[context.entryModel.get('paymentType')]);
      } else {
        paymentTypeText = 'not registered';
      }
      this.trackStartEvent('Initialize First', paymentTypeText);
    },
    onStartTrackConfirmPaymenttype(context) {
      let actionText = 'Create More';
      this.trackEvent = 'Started More';
      if (context.entryModel.get('isNewSubOnlyBankcardFirstTime')) {
        this.trackEvent = 'Started First';
        actionText = 'Initialize First';
      }
      this.trackStartEvent(actionText, this.CONSTANTS[context.entryModel.get('paymentType')]);
      this.view.triggerMethod('start:userConfirmPaymenttype');
    },
    onStartTrackSelectedPaymenttype(context) {
      let actionText = 'Create More';
      this.trackEvent = 'Started More';
      if (context.entryModel.get('isNewSubOnlyBankcardFirstTime')) {
        this.trackEvent = 'Started First';
        actionText = 'Initialize First';
      }
      this.trackStartEvent(actionText, this.CONSTANTS[context.entryModel.get('paymentType')]);
    },
    trackStartEvent(actionText, paymentTypeText) {
      const track = {
        category: 'Subscription',
        action: "".concat(actionText, " : ").concat(this.productName),
        opt_label: paymentTypeText,
        opt_value: this.weeklyCost
      };
      svs.tur.start_subscription.logger.debug('TrackGa:trackStartEvent - ', track.action, track.opt_label, track.opt_value);
      svs.components.analytics.trackEvent(track);
    },
    onChangeSubscription() {
      this.trackEvent = 'Changed';
    },
    onSaveTrackingFromWager(context, successCallback) {
      const trackingWager = this.createTrackingFromWager(context.entryModel.get('subscriptionEntry').wagers, context.entryModel.get('subscriptionOptions'));
      const trackingData = this.createGaTrackingData(context.entryModel, trackingWager, this.trackEvent);
      this.saveGaTrackingData(trackingData, context, successCallback);
    },
    createGaTrackingData(entryModel, wager, eventType) {
      const paymentType = entryModel.get('isBankcard') ? this.CONSTANTS.BANK_CARD : this.CONSTANTS.AUTOGIRO;
      const event = {
        category: 'Subscription',
        action: "".concat(eventType, " : ").concat(wager.product),
        opt_label: paymentType,
        opt_value: parseFloat(entryModel.get('amount'))
      };
      const items = wager.trackingBets.map(bet => new svs.components.analytics.transactionItem(bet.productId, bet.productName, bet.price, bet.quantity, {
        paymentType,
        rounds: 'Subscription'
      }));
      const transaction = {
        subscriptionId: entryModel.get('newSubId'),
        weeklyCost: entryModel.has('subscriptionOptions') ? entryModel.get('subscriptionOptions').weeklyCost : wager.totalWeeklyAmount,
        items,
        product: wager.product
      };
      return {
        event,
        transaction
      };
    },
    onStartCancelDropdownBeforeFirstPayBankcardSubscription() {
      svs.components.analytics.trackEvent({
        category: 'Subscription',
        action: 'Before First Pay Cancel Dropdown',
        opt_label: 'creditcard'
      });
    },
    onStartCancelDropdownFirstPayBankcardSubscription() {
      svs.components.analytics.trackEvent({
        category: 'Subscription',
        action: 'First Pay Cancel Dropdown',
        opt_label: 'creditcard'
      });
    },
    onStartCancelButtonBeforeFirstPayBankcardSubscription() {
      svs.components.analytics.trackEvent({
        category: 'Subscription',
        action: 'Before First Pay Cancel Button',
        opt_label: 'creditcard'
      });
    },
    onStartCancelButtonFirstPayBankcardSubscription() {
      svs.components.analytics.trackEvent({
        category: 'Subscription',
        action: 'First Pay Cancel Button',
        opt_label: 'creditcard'
      });
    },
    onStartCancelCloseTabBrowserFirstPayBankcardSubscription() {
      svs.components.analytics.trackEvent({
        category: 'Subscription',
        action: 'First Pay Cancel Tab or Browser',
        opt_label: 'creditcard'
      });
    },

    onEnableActivationConfirmed(status) {
      const notANumberStatus = isNaN(status) ? 1 : status;
      const _status = isNaN(status) && status && status.entryModel ? status.entryModel.get('status') : notANumberStatus;
      this.trackEvent = this.CONSTANTS.STATUS[_status];
    },
    onSaveTrackingFromSubscription(context, successCallback) {
      let subscription = {};
      if (svs && svs.subscription_management && svs.subscription_management && svs.subscription_management.utils && svs.subscription_management.utils.getTrackingData && typeof svs.subscription_management.utils.getTrackingData === 'function') {
        subscription = svs.subscription_management.utils.getTrackingData();
      } else {
        subscription = this.view.getTrackingData && this.view.getTrackingData(context.entryModel.get('subscriptionId'));
      }
      const trackingData = this.createTrackingFromSubWager(context.entryModel, subscription, this.trackEvent);
      this.saveGaTrackingData(trackingData, context, successCallback);
    },
    onShowNewSubscription(newSubscription, oldSubscriptionId, context) {
      const newSub = newSubscription && newSubscription.subscription || newSubscription && newSubscription.GetSubscriptionRequest && newSubscription.GetSubscriptionRequest.subscription || {};
      const trackingData = this.createTrackingFromSubWager(context.entryModel, newSub, this.trackEvent);
      this.sendGaTracking(trackingData);
    },
    createTrackingFromSubWager(entryModel, subscription, event) {
      var _subscription$subwage;
      const subWagers = subscription.subwagers;
      const totalWeeklyAmount = parseInt(subscription.weeklyAmount, 10) || 0;
      const addonAmount = parseInt(subscription.addonAmount, 10) || 0;
      const isLyckoplatsen = ((_subscription$subwage = subscription.subwagers) === null || _subscription$subwage === void 0 || (_subscription$subwage = _subscription$subwage[0]) === null || _subscription$subwage === void 0 || (_subscription$subwage = _subscription$subwage.productName) === null || _subscription$subwage === void 0 ? void 0 : _subscription$subwage.toLowerCase()) === this.CONSTANTS.LYCKOPLATSEN.productName.toLowerCase();
      const trackingBets = [];
      let pricePerDraw;
      let product;
      _.each(subWagers, subWager => {
        if (!pricePerDraw) {
          const numPlayDays = subWager.productIds.length;
          if (isLyckoplatsen) {
            pricePerDraw = totalWeeklyAmount;
          } else {
            pricePerDraw = (totalWeeklyAmount - addonAmount * numPlayDays) / numPlayDays / subWager.numDraws;
          }
          product = subWager.productName.replace('&', ',');
        }
        _.each(subWager.productIds, productIdNum => {
          let price;
          if (isLyckoplatsen) {
            var _this$CONSTANTS$LYCKO, _this$CONSTANTS$LYCKO2;
            const isLyckoplatsenPrimary = ((_this$CONSTANTS$LYCKO = this.CONSTANTS.LYCKOPLATSEN.itsId) === null || _this$CONSTANTS$LYCKO === void 0 ? void 0 : _this$CONSTANTS$LYCKO[productIdNum]) === this.CONSTANTS.LYCKOPLATSEN.LYCKOPLATSEN_PRIMARY;
            price = isLyckoplatsenPrimary ? pricePerDraw : 0;
            const quantity = isLyckoplatsenPrimary ? subWager.boards.length : 0;
            trackingBets.push({
              productId: (_this$CONSTANTS$LYCKO2 = this.CONSTANTS.LYCKOPLATSEN.itsId) === null || _this$CONSTANTS$LYCKO2 === void 0 ? void 0 : _this$CONSTANTS$LYCKO2[productIdNum],
              price,
              productName: this.CONSTANTS.LYCKOPLATSEN.productName,
              quantity
            });
          } else {
            for (let i = 1; i <= subWager.numDraws; i++) {
              const productId = productMappingNumbergames.getProductItsId(productIdNum);
              let productName;
              switch (productId) {
                case productMappingNumbergames.CONSTANTS.LOTTO_WEDNESDAY:
                case productMappingNumbergames.CONSTANTS.LOTTO_SATURDAY:
                  productName = "".concat(productMappingNumbergames.getProductName(productId), " ").concat(i, " ").concat(productMappingNumbergames.getDay(productId));
                  price = pricePerDraw;
                  break;
                case productMappingNumbergames.CONSTANTS.JOKER_WEDNESDAY:
                case productMappingNumbergames.CONSTANTS.JOKER_SATURDAY:
                  productName = "".concat(productMappingNumbergames.getProductName(productId), " ").concat(productMappingNumbergames.getDay(productId));
                  price = addonAmount;
                  break;
                default:
                  productName = productMappingNumbergames.getProductDayName(productId);
                  price = pricePerDraw;
              }
              trackingBets.push({
                productId,
                price,
                productName,
                quantity: subWager.boards.length
              });
            }
          }
        });
      });
      const trackingWager = {
        product,
        trackingBets,
        totalWeeklyAmount,
        subscriptionId: subscription.subscriptionId || subscription.subscrId
      };
      return this.createGaTrackingData(entryModel, trackingWager, event);
    },
    createTrackingFromWager(wagers, _ref) {
      var _product;
      let product = _ref.product,
        gameDays = _ref.gameDays;
      const trackingBets = [];
      const isLyckoplatsen = ((_product = product) === null || _product === void 0 ? void 0 : _product.toLowerCase()) === this.CONSTANTS.LYCKOPLATSEN.productName.toLowerCase();

      if (productMappingNumbergames.isProductFamily(product)) {
        product = "".concat(product, " ").concat(gameDays);
      }
      wagers.forEach(wager => {
        const day = productMappingNumbergames.getDay(wager.bets[0].productId);
        wager.bets.forEach(bet => {
          var _this$CONSTANTS$LYCKO3, _this$CONSTANTS$LYCKO4;
          const productName = isLyckoplatsen ? this.CONSTANTS.LYCKOPLATSEN.productName : productMappingNumbergames.getProductName(bet.productId);
          const isLyckoplatsenPrimary = ((_this$CONSTANTS$LYCKO3 = this.CONSTANTS.LYCKOPLATSEN.wagersId) === null || _this$CONSTANTS$LYCKO3 === void 0 ? void 0 : _this$CONSTANTS$LYCKO3[bet.productId]) === this.CONSTANTS.LYCKOPLATSEN.LYCKOPLATSEN_PRIMARY;
          const quantity = isLyckoplatsen && !isLyckoplatsenPrimary ? 0 : 1;
          const trackingBet = {
            productName,
            productId: isLyckoplatsen ? (_this$CONSTANTS$LYCKO4 = this.CONSTANTS.LYCKOPLATSEN.wagersId) === null || _this$CONSTANTS$LYCKO4 === void 0 ? void 0 : _this$CONSTANTS$LYCKO4[bet.productId] : bet.productId,
            price: parseInt(bet.betAmountSalesGroup1, 10),
            quantity
          };
          switch (bet.productId) {
            case productMappingNumbergames.CONSTANTS.LOTTO_WEDNESDAY:
            case productMappingNumbergames.CONSTANTS.LOTTO_SATURDAY:
              trackingBets.push(_objectSpread(_objectSpread({}, trackingBet), {}, {
                productName: "".concat(productName, " 1 ").concat(day)
              }));
              if (bet.betAmountSalesGroup2 > 0) {
                trackingBets.push(_objectSpread(_objectSpread({}, trackingBet), {}, {
                  productName: "".concat(productName, " 2 ").concat(day)
                }));
              }
              break;
            case productMappingNumbergames.CONSTANTS.EUROJACKPOT_TUESDAY:
            case productMappingNumbergames.CONSTANTS.EUROJACKPOT_FRIDAY:
            case productMappingNumbergames.CONSTANTS.JOKER_WEDNESDAY:
            case productMappingNumbergames.CONSTANTS.JOKER_SATURDAY:
              trackingBets.push(_objectSpread(_objectSpread({}, trackingBet), {}, {
                productName: "".concat(productName, " ").concat(day)
              }));
              break;
            default:
              trackingBets.push(trackingBet);
          }
        });
      });
      return {
        product,
        trackingBets
      };
    },

    onSubscriptionCancelled(subscriptionId) {
      const paymentMethod = this.view.getSubscriptionPaymentMethod && this.view.getSubscriptionPaymentMethod();
      const productName = this.view.getProductName ? this.view.getProductName(subscriptionId) : this.view.model.get('productName');
      const track = {
        category: 'Subscription',
        action: "Ended : ".concat(productName),
        opt_label: this.CONSTANTS[paymentMethod]
      };
      svs.tur.start_subscription.logger.debug('TrackGa:onSubscriptionCancelled', track.action, track.opt_label);
      svs.components.analytics.trackEvent(track);
    },

    onSendSavedTrackingData(callback) {
      svs.components.Storage.browser.get('tracksubscription', 'subscription', data => {
        if (data) {
          this.sendGaTracking(data);
          svs.components.Storage.browser.remove('tracksubscription', 'subscription', err => {
            if (err) {
              svs.tur.start_subscription.logger.warn('Failed to remove tracking data, the log might trigger more than once ', err);
            }
            callback && callback();
          });
        } else {
          callback && callback();
        }
      });
    },
    saveGaTrackingData(trackingData, context, successFn) {
      svs.components.Storage.browser.set('tracksubscription', 'subscription', _objectSpread({}, trackingData), svs.components.Storage.constants.EXPIRES_10M, () => successFn && successFn.call(context));
    },
    sendGaTracking(data) {
      const transaction = new svs.components.analytics.transaction(data.transaction.subscriptionId, data.transaction.weeklyCost, data.transaction.items, 0, 0, undefined, data.transaction.product);
      svs.tur.start_subscription.logger.debug('TrackGa:sendGaTracking', data.event, transaction);
      svs.components.analytics.trackEvent(data.event);
      svs.components.analytics.trackTransaction(transaction);
    }
  });
})(Backbone, _, svs);

 })(window);